import { yieldToEventLoop } from '../../runtime/yield-to-event-loop.js';
import {
  isCliImmediateShutdownRequested,
} from '../../runtime/cli-process-interrupt.js';
import { isSymbolIndexWorkerShutdownRequested } from '../../code-nav/symbol-index/worker/shutdown-state.js';
import { CliSqliteInterrupted } from '../sqlite-errors.js';

/** Nested code-nav SQLite opens on the same stack (reentrant work lock). */
let codeNavCacheAccessDepth = 0;

async function waitForOuterCodeNavCacheAccessAsync(): Promise<void> {
  while (codeNavCacheAccessDepth > 0) {
    if (isCliImmediateShutdownRequested() || isSymbolIndexWorkerShutdownRequested()) {
      throw new CliSqliteInterrupted();
    }
    await new Promise<void>((resolve) => setTimeout(resolve, 5));
    await yieldToEventLoop();
  }
}

function waitForOuterCodeNavCacheAccessSync(): void {
  while (codeNavCacheAccessDepth > 0) {
    if (isCliImmediateShutdownRequested() || isSymbolIndexWorkerShutdownRequested()) {
      throw new CliSqliteInterrupted();
    }
    const end = Date.now() + 5;
    while (Date.now() < end) {
      if (isCliImmediateShutdownRequested() || isSymbolIndexWorkerShutdownRequested()) {
        throw new CliSqliteInterrupted();
      }
    }
  }
}

export function getCodeNavCacheAccessDepth(): number {
  return codeNavCacheAccessDepth;
}

export function incrementCodeNavCacheAccessDepth(): void {
  codeNavCacheAccessDepth += 1;
}

export function decrementCodeNavCacheAccessDepth(): void {
  codeNavCacheAccessDepth = Math.max(0, codeNavCacheAccessDepth - 1);
}

export async function waitForOuterCodeNavCacheAccessIfNeededAsync(nested: boolean): Promise<void> {
  if (!nested) await waitForOuterCodeNavCacheAccessAsync();
}

export function waitForOuterCodeNavCacheAccessIfNeededSync(nested: boolean): void {
  if (!nested) waitForOuterCodeNavCacheAccessSync();
}

export function resetCodeNavCacheAccessDepth(): void {
  codeNavCacheAccessDepth = 0;
}
